module.exports = __webpack_public_path__ + "img/Icons-Job Alert.d1b0b4b7.svg";